import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getOrganisationProjectsApi } from '../../../services/api';

/**
 * board_summary/board_column (the APIs the Kanban board renders from) don't carry
 * quick-turn info, but GET /api/v1/events does. This hook paginates through that
 * endpoint once per organisation and returns an id -> quick-turn-fields lookup so
 * board cards can be enriched client-side without a backend change.
 */
export const useQuickTurnLookup = (orgId) => {
  const query = useQuery(
    ['quick-turn-lookup', orgId],
    async () => {
      let page = 1;
      let events = [];
      while (page) {
        const response = await getOrganisationProjectsApi({ organisation_id: orgId, page });
        const data = response?.data?.data;
        events = events.concat(data?.event_details ?? []);
        page = data?.next_page ?? null;
      }
      return events;
    },
    { enabled: !!orgId, staleTime: 30_000 }
  );

  return useMemo(() => {
    const lookup = {};
    (query.data ?? []).forEach((event) => {
      lookup[event.id] = {
        quick_turn: event.quick_turn,
        quick_turn_status: event.quick_turn_status,
        quick_turn_rejection_note: event.quick_turn_rejection_note,
      };
    });
    return lookup;
  }, [query.data]);
};
